export default "__VITE_ASSET__BpQcG6P$__"